import type { GetInvoicesSummaryReportResponse } from '@vy/api-definition';
import { GetInvoicesSummaryReportResponseSchema } from '@vy/api-definition';
import type { UseQueryOptions } from 'react-query';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { USE_CACHE_HEADER } from '../../services/api/cache-headers';
import { queryKeys } from '../../services/query-key/query-keys';

export function useGetInvoicesSummaryReport(options?: UseQueryOptions<GetInvoicesSummaryReportResponse>) {
  const invoicesSummaryReportQuery = useQuery({
    queryKey: queryKeys.invoicesSummaryReport(),
    queryFn: async () => {
      const api = getPrivateApi();

      const getInvoicesSummaryReportResponse = await api.getInvoicesSummaryReport(USE_CACHE_HEADER);

      return GetInvoicesSummaryReportResponseSchema.parse(getInvoicesSummaryReportResponse);
    },
    suspense: true,
    ...options,
  });

  return invoicesSummaryReportQuery;
}
